import type { Translations } from '../../types'

const pluginsMessages: Translations = {
  "plugins.title": "Gestione Plugin",
  "plugins.description": "Installa e gestisci plugin runtime e pacchetti Product Type",
  "plugins.upload.title": "Installa pacchetto",
  "plugins.upload.description": "Carica uno ZIP contenente un plugin runtime o un pacchetto Product Type",
  "plugins.upload.button": "Installa pacchetto ZIP",
  "plugins.upload.uploading": "Caricamento...",
  "plugins.upload.success": "Pacchetto installato con successo!",
  "plugins.upload.detectedService": "Destinazione pacchetto rilevata: {{service}}",
  "plugins.upload.enableHint": "Il plugin è stato registrato. Abilitalo per iniziare ad usarlo.",
  "plugins.upload.error": "Caricamento fallito",
  "plugins.upload.dragDrop": "Trascina e rilascia qui i file del pacchetto",
  "plugins.upload.drop": "Rilascia i pacchetti da installare",
  "plugins.upload.dragDescription": "Supporta installazioni singole o multiple. Accetta solo file .zip",
  "plugins.upload.browseFiles": "Sfoglia File",
  "plugins.filters.status": "Stato",
  "plugins.filters.all": "Tutti",
  "plugins.filters.enabled": "Abilitati",
  "plugins.filters.disabled": "Disabilitati",
  "plugins.filters.broken": "Danneggiati",
  "plugins.filters.service": "Servizio",
  "plugins.filters.hostService": "Servizio Host",
  "plugins.filters.allServices": "Tutti i Servizi",
  "plugins.status.enabled": "Abilitato",
  "plugins.status.disabled": "Disabilitato",
  "plugins.status.installed": "Installato",
  "plugins.status.broken": "Danneggiato",
  "plugins.status.updated": "Stato aggiornato",
  "plugins.status.updateSuccess": "Plugin {{status}} con successo",
  "plugins.status.updateError": "Impossibile aggiornare lo stato",
  "plugins.actions.enable": "Abilita",
  "plugins.actions.disable": "Disabilita",
  "plugins.actions.delete": "Elimina",
  "plugins.actions.resetHealth": "Reset Salute",
  "plugins.actions.refresh": "Aggiorna",
  "plugins.register.success": "Plugin registrato",
  "plugins.register.successMessage": "Plugin registrato con successo",
  "plugins.register.error": "Impossibile registrare plugin",
  "plugins.unregistered.status": "Non registrato",
  "plugins.unregistered.register": "Registra",
  "plugins.unregistered.inlineCount": "{{count}} da registrare",
  "plugins.unregistered.bulkSuccessTitle": "Registrazione completata",
  "plugins.unregistered.bulkPartialTitle": "Registrazione parziale",
  "plugins.unregistered.bulkResult": "{{success}} registrati, {{failed}} falliti (su {{total}})",
  "plugins.delete.title": "Elimina Plugin",
  "plugins.delete.confirm": "Sei sicuro di voler eliminare",
  "plugins.delete.warning": "Questo rimuoverà tutti i file del plugin e non può essere annullato.",
  "plugins.delete.button": "Elimina",
  "plugins.delete.success": "Plugin eliminato",
  "plugins.delete.successMessage": "{{name}} è stato rimosso con successo",
  "plugins.delete.error": "Impossibile eliminare",
  "plugins.health.reset": "Salute resettata",
  "plugins.health.resetSuccess": "I contatori di salute sono stati resettati",
  "plugins.health.resetError": "Impossibile resettare la salute",
  "plugins.details.version": "Versione",
  "plugins.details.service": "Servizio",
  "plugins.details.status": "Stato",
  "plugins.details.author": "Autore",
  "plugins.details.capabilities": "Capacità",
  "plugins.details.errors": "Errori",
  "plugins.details.id": "ID",
  "plugins.details.type": "Tipo",
  "plugins.details.consecutive": "consecutivi",
  "plugins.details.autoDisabled": "Auto-disabilitato per errori",
  "plugins.stats.total": "Plugin Totali",
  "plugins.stats.enabled": "Abilitati",
  "plugins.stats.disabled": "Disabilitati",
  "plugins.stats.broken": "Danneggiati",
  "plugins.empty.title": "Nessun plugin",
  "plugins.empty.description": "Carica il tuo primo plugin per iniziare",
  "plugins.loading": "Caricamento plugin...",
  "plugins.table.plugin": "Plugin",
  "plugins.table.actions": "Azioni",
  "plugins.table.preview": "Anteprima plugin",
  "plugins.errors.pageTitle": "Errori Plugin",
  "plugins.errors.subtitle": "Diagnostica runtime per {{name}}",
  "plugins.errors.refresh": "Aggiorna",
  "plugins.errors.back": "Torna alla lista plugin",
  "plugins.errors.consecutive": "Errori consecutivi",
  "plugins.errors.listTitle": "Lista errori",
  "plugins.errors.lastErrorAt": "Timestamp: {{date}}",
  "plugins.errors.noLastError": "Nessun messaggio di errore disponibile.",
  "plugins.errors.notAvailable": "Non disponibile",
  "plugins.errors.notFoundTitle": "Plugin non trovato",
  "plugins.errors.notFoundDescription": "Il plugin richiesto non è disponibile o non è visibile con i filtri correnti.",
  "plugins.list.dragHint": "Trascina plugin ZIP nella lista per installarlo",
  "plugins.bulk.selected": "{{count}} selezionati",
  "plugins.bulk.selectAll": "Seleziona tutti",
  "plugins.bulk.clear": "Pulisci selezione",
  "plugins.bulk.enable": "Abilita selezionati",
  "plugins.bulk.disable": "Disabilita selezionati",
  "plugins.bulk.resetHealth": "Reset salute",
  "plugins.bulk.delete": "Elimina selezionati",
  "plugins.bulk.completed": "Operazione completata",
  "plugins.bulk.completedMessage": "{{action}}: {{success}}/{{total}} completati",
  "plugins.bulk.partial": "Operazione parziale",
  "plugins.bulk.partialMessage": "{{action}}: {{success}} ok, {{failed}} falliti (su {{total}})",
  "plugins.bulk.deleteTitle": "Elimina plugin selezionati",
  "plugins.bulk.deleteConfirm": "Vuoi eliminare {{count}} plugin selezionati? Questa azione non puo essere annullata.",
  "plugins.pagination.show": "Mostra",
  "plugins.pagination.itemsPerPage": "plugin per pagina",
  "plugins.pagination.summary": "Pagina {{page}} di {{totalPages}} ({{totalItems}} plugin)",
  "plugins.pagination.prev": "Precedente",
  "plugins.pagination.next": "Successiva",
  "plugins.pagination.pageSelect": "Seleziona pagina",
  "plugins.preview.label": "Preview plugin",
  "plugins.preview.close": "Chiudi anteprima",
  "plugins.preview.permissions": "Permessi concessi",
  "plugins.preview.none": "Nessun dato",
  "plugins.preview.unknown": "Sconosciuto"
}

export default pluginsMessages
